import type { BuildFilters, EnvVarFilters, ShadowRunFilters } from './endpoints';

export const qk = {
  me: ['me'] as const,
  projects: ['projects'] as const,
  apps: (projectId: string) => ['apps', projectId] as const,
  builds: (filters: BuildFilters) => ['builds', filters] as const,
  build: (id: string) => ['build', id] as const,
  buildEvents: (id: string) => ['build', id, 'events'] as const,
  buildChecks: (id: string) => ['build', id, 'checks'] as const,
  buildArtifacts: (id: string) => ['build', id, 'artifacts'] as const,
  buildEnv: (id: string) => ['build', id, 'env'] as const,
  queue: (projectId?: string) => ['queue', projectId ?? ''] as const,
  profiles: (appId: string) => ['profiles', appId] as const,
  launchForm: (profileId: string, env: string, platform: string, branch: string) => ['launch-form', profileId, env, platform, branch] as const,
  envVars: (filters: EnvVarFilters) => ['env-vars', filters] as const,
  envVarVersions: (id: string) => ['env-var', id, 'versions'] as const,
  envRequirements: (appId: string) => ['env-requirements', appId] as const,
  /** Under the `env-vars` prefix on purpose: every env var write (which invalidates `['env-vars']`) refreshes it. */
  envResolve: (appId: string, environment: string, platform: string) => ['env-vars', 'resolve', appId, environment, platform] as const,
  providerAccounts: ['provider-accounts'] as const,
  scmConnections: ['scm-connections'] as const,
  scmRepositories: (id: string, query: string) => ['scm-connections', id, 'repositories', query] as const,
  bitriseSetup: (appId: string) => ['bitrise-setup', appId] as const,
  /** Both lists (live only, and with revoked tokens) share the `['api-tokens']` prefix. */
  apiTokens: (includeRevoked: boolean) => ['api-tokens', includeRevoked ? 'all' : 'live'] as const,
  oidcPolicies: ['oidc-policies'] as const,
  shadow: (appId: string) => ['shadow', appId] as const,
  /** Every runs list of an app shares the `['shadow-runs', appId]` prefix, so one invalidation refreshes all filters. */
  shadowRuns: (appId: string, filters: ShadowRunFilters) => ['shadow-runs', appId, filters] as const,
  shadowRun: (id: string) => ['shadow-run', id] as const,
  usageLimits: ['usage-limits'] as const,
  usage: (month: string) => ['usage', month] as const,
  tutorials: ['tutorials'] as const,
};
